import { takeLatest, put, call } from 'redux-saga/effects';
import {
    FETCH_CORRESPONDENT_LIST,
    fetchCorrespondentListSuccess,
    fetchCorrespondentListFailure,
    ENABLE_CORRESPONDENT,
    enableCorrespondentFailure,
    enableCorrespondentSuccess,
    DELETE_CORRESPONDENT_ENTITY,
    deleteCorrespondentEntityFailure,
    deleteCorrespondentEntitySuccess

} from './action';
import { HTTP_HEADERS } from '../../../constants';
import request from '../../../components/Utils/httpHelper';
import { CORE_API } from '../../../config';

export function* getCorrespondentList() {

    let requestUrl = `${CORE_API}/correspondent/entity/list`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(fetchCorrespondentListSuccess(createResult.data));
    } catch (err) {
        yield put(fetchCorrespondentListFailure(err))
    }
}
export function* getCorrespondent() {
    yield takeLatest(FETCH_CORRESPONDENT_LIST, getCorrespondentList);
}

export function* enableCorrespondent(action) {
    let requestUrl = `${CORE_API}/correspondent/entity/${action.data}/enable`;
    try {
        const result = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(enableCorrespondentSuccess(result))
    } catch (err) {
        yield put(enableCorrespondentFailure(err))
    }
}
export function* enableCorrespondentEntity() {
    yield takeLatest(ENABLE_CORRESPONDENT, enableCorrespondent)
}

export function* deleteCorrespondent(action) {
    let requestUrl = `${CORE_API}/correspondent/entity/${action.data}`;
    try {
        const result = yield call(request, requestUrl, { method: 'DELETE', headers: HTTP_HEADERS });
        yield put(deleteCorrespondentEntitySuccess(result))
    } catch (err) {
        yield put(deleteCorrespondentEntityFailure(err))
    }
}
export function* deleteCorrespondentEntity() {
    yield takeLatest(DELETE_CORRESPONDENT_ENTITY, deleteCorrespondent)
}